import { toast } from 'react-toastify';

export class UserEventsChecker {
    eventTimer = null;
    eventCounter = 1;
    eventLeftTimer = null;
    eventLeftPoint = 0;

    appAuth = null;
    lastPointRefreshToken = 0;

    fns = ['focus', 'change', 'blur', 'select', 'contextmenu', 'drop', 'keydown',
        'copy', 'paste', 'scroll', 'resize', 'reset',
        'dblclick', 'click', 'mousedown', 'mouseup', 'mousemove', 'mouseover'].map(t => {
            return {
                type: t,
                fn: (event) => {
                    this.eventHandler(event);
                }
            }
        })

    registerEvents(appAuth) {
        this.appAuth = appAuth;
        this.fns.forEach(t => {
            let { type, fn } = t
            this.unbindingEvent(window, type, fn);
            this.bindingEvent(window, type, fn);
        });
    }

    removeAllEvents() {
        this.fns.forEach(t => {
            let { type, fn } = t
            this.unbindingEvent(window, type, fn);
        });
    }

    unbindingEvent(element, type, fn) {
        try {
            if (element.removeEventListener) {
                element.removeEventListener(type, fn, false);
            } else if (element.detachEvent) {
                element.detachEvent(`on${type}`, fn);
            }
        } catch (error) {
            //
        }
    }

    bindingEvent(element, type, fn) {
        if (element.addEventListener) {
            element.addEventListener(type, fn, false);
        } else if (element.attachEvent) {
            element.attachEvent(`on${type}`, fn);
        }
    }

    eventHandler(event) {
        // console.log('event', this.eventCounter, event)
        // clean up
        if (this.eventTimer) {
            clearTimeout(this.eventTimer);
        }
        if (this.eventLeftTimer) {
            clearInterval(this.eventLeftTimer);
            this.eventLeftTimer = null;
        }
        // checking as counter
        if (this.eventCounter > 300) {
            // console.log('checking get counter-point', this.eventCounter);
            this.eventCounter = 0;
            this.refreshUserSession();
        }
        // checking as 10 secs
        this.eventTimer = setTimeout(() => {
            // console.log('checking get started an interval');
            this.eventCounter = 0;
            this.refreshUserSession();
            this.userLeft()
        }, 10000);//10 seconds
        this.eventCounter++;
    }

    userLeft() {
        this.eventLeftPoint = new Date().getTime();
        this.eventLeftTimer = setInterval(() => {
            let now = new Date().getTime();
            let dis =  (now - this.eventLeftPoint) - this.appAuth.MAX_LEFT_TIME;
            // let min = Math.round(dis / 1000 / 60)
            // let secs = Math.round(dis / 1000 - min * 60)
            // console.log('user left / countdown:', min, 'mins', secs, 'secs`')
            if (dis >= 0) {
                this.doLogout()
            }
        }, 60000);//in 1 minute
    }

    clearSessionEvent() {
        if (this.eventTimer) {
            clearTimeout(this.eventTimer);
        }
        if (this.eventLeftTimer) {
            clearInterval(this.eventLeftTimer);
            this.eventLeftTimer = null;
        }
        this.removeAllEvents()
    }

    doLogout() {
        if (this.appAuth) {
            this.appAuth.isUserSessionExpired = true
            if (this.appAuth.doLogout) {
                this.appAuth.doLogout();
            }
        }
        this.clearSessionEvent()
    }

    async refreshToken() {
        let now = new Date().getTime();
        if (this.lastPointRefreshToken && (now - this.lastPointRefreshToken) < 3 * 60 * 1000) {
            return;
        }
        console.log("Refreshing the token now");
        this.lastPointRefreshToken = new Date().getTime()
        if (this.appAuth && this.appAuth.refreshAuthJWT) {
            try {
                await this.appAuth.refreshAuthJWT();
            } catch (error) {

            }
        }
    }

    refreshUserSession() {
        // console.log('Checking access token expired or not?', this.appAuth.isTokenExpired, this.appAuth.isTokenAboutToExpire )
        if (this.appAuth && this.appAuth.token && this.appAuth.isTokenExpired) {
            console.log('Session Expired!')
            // toast.warn('Session Expired! \n Your current session is expired. Please login again')
            this.doLogout();
        } else if (this.appAuth && this.appAuth.token && this.appAuth.isTokenAboutToExpire) {
            //refresh the token
            this.refreshToken();
        }
    }
}

export const userEventsChecker = new UserEventsChecker();